import { render, staticRenderFns } from "./Employees.vue?vue&type=template&id=c4a284a8&scoped=true&lang=pug"
import script from "./Employees.vue?vue&type=script&lang=js"
export * from "./Employees.vue?vue&type=script&lang=js"
import style0 from "./Employees.vue?vue&type=style&index=0&id=c4a284a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a284a8",
  null
  
)

export default component.exports